import { useArchiveCandidate } from '../hooks'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

export function CandidateArchiveButton({
    candidateIds,
    onSuccess,
}: {
    candidateIds: string[]
    onSuccess?: () => void
}) {
    const mutation = useArchiveCandidate()
    const { t } = useTranslation()

    return (
        <Button
            type="primary"
            loading={mutation.isPending}
            onClick={() => mutation.mutateAsync({ candidates: candidateIds }).then(onSuccess)}
        >
            ({candidateIds.length}) {t('Archive selected candidates')}
        </Button>
    )
}
